import React from "react";
import { Star, Quote } from "lucide-react";

const testimonials = [
  {
    name: "María Fernanda P.",
    role: "Santiago",
    img: "https://images.unsplash.com/photo-1544725176-7c40e5a71c5e?crop=entropy&cs=srgb&fm=jpg&w=200&q=75",
    text: "Me ayudó mucho poder comparar ofertas en un solo lugar. Al final elegí la entidad que tenía mejor CAE y cuota para mi presupuesto.",
  },
  {
    name: "Rodrigo A.",
    role: "Valparaíso",
    img: "https://images.unsplash.com/photo-1713947507130-227586ab3024?crop=entropy&cs=srgb&fm=jpg&w=200&q=75",
    text: "Valoré mucho la claridad: me quedó claro desde el inicio que Bancoorp es intermediario y que la decisión final depende del banco.",
  },
  {
    name: "Camila R.",
    role: "Concepción",
    img: "https://images.unsplash.com/photo-1581322929625-f4aab333778a?crop=entropy&cs=srgb&fm=jpg&w=200&q=75",
    text: "Recibí varias propuestas y pude tomar una decisión informada. Proceso ordenado y sin presión para aceptar ninguna oferta.",
  },
];

export default function Testimonials() {
  return (
    <section
      className="py-20 lg:py-28 bg-slate-50 border-y border-slate-200"
      data-testid="testimonials-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <span className="text-sm uppercase tracking-[0.2em] font-bold text-blue-600">
            Testimonios
          </span>
          <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-900">
            Historias reales de personas que compararon antes de decidir
          </h2>
          <p className="mt-4 text-sm text-slate-500">
            Testimonios representativos de usuarios que utilizaron nuestro
            servicio. Los resultados varían según perfil crediticio.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 lg:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="rounded-2xl bg-white border border-slate-200 p-7 flex flex-col transition-all duration-300 hover:-translate-y-1 hover:shadow-lg"
              data-testid={`testimonial-${i}`}
            >
              <Quote className="h-7 w-7 text-teal-500" strokeWidth={1.5} />
              <p className="mt-4 text-slate-700 leading-relaxed text-sm">
                “{t.text}”
              </p>
              <div className="mt-6 pt-5 border-t border-slate-100 flex items-center gap-3">
                <img
                  src={t.img}
                  alt={t.name}
                  className="h-11 w-11 rounded-full object-cover"
                  loading="lazy"
                />
                <div className="flex-1">
                  <div className="font-semibold text-slate-900 text-sm">
                    {t.name}
                  </div>
                  <div className="text-xs text-slate-500">{t.role}</div>
                </div>
                <div className="flex gap-0.5">
                  {Array.from({ length: 5 }).map((_, s) => (
                    <Star
                      key={s}
                      className="h-3.5 w-3.5 fill-amber-400 text-amber-400"
                    />
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
